/**
 * Упреждение ротации (планировщик) и порог «свежести» access (оркестратор) — одно значение: при пороге больше
 * упреждения планировщик запускал бы ротацию, оркестратор считал бы access свежим и сразу возвращал true, и таймер тут
 * же стрелял бы снова.
 */
export const REFRESH_LEAD_MS = 75_000;

/**
 * Не раньше, чем через столько, планировщик ротирует снова: access, который по часам клиента уже истёк (часы впереди
 * сервера) или живёт секунды, иначе ротировался бы без остановки.
 */
export const MIN_REFRESH_DELAY_MS = 10_000;

/**
 * Потолок RefreshToken и SignOut: ротация держит Web Lock всех вкладок, зависший запрос без него держал бы его до
 * закрытия вкладки.
 */
export const AUTH_REQUEST_TIMEOUT_MS = 30_000;
